export default "#### Debit or credit card\n\nInstant transaction. Fees apply.\n";